import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import { useTheme } from '@mui/material';
import MotivoTicketService from '../../services/motivoTicket.service';


const SelectMotivoTicket = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    isDisabled,
    emp,
    isMulti,
    instalacion,
    contrato,
    contratoSoft,
    filterExist
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [items, setItems] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState();
    const onSelectValue = (ev) => {
        if(Array.isArray(ev)){
            onChange(ev.map(e=>{
                const item = items.find(it=>it.id_mt === e.value);
                return {
                    ...e,
                    item: item,
                }
            }));
        }else{
            setSelectedValue(ev);
            onChange(ev);
        }
    };
    useEffect(() => {
        if(emp){
            MotivoTicketService.getAll({ emp:emp }).then((resp)=>{
                setItems(resp)
            })
        }else{
            MotivoTicketService.getAll().then((resp)=>{
                setItems(resp)
            })
        }
    }, [])

    useEffect(() => {
        const newOptions = items.map((item) => {
            return {
                value: item.id_mt,
                label: item.motivo_mt,
                descripcion: item.cuerpo_mt,
                destino: item.grupoId_mt,
                tipoTicket: item.tipoTicketId_mt,
                subTipoTicket: item.subTipoTicketId_mt,
                nivelAdm: item.nivelAdmTkId_mt,
                motivoBaja: item.motivoBajaTk_mt,
                dayResolucion: item.dayResolucion_mt,
                tipoTareaId: item.tipoTareaId_mt,
                ...item
            };
        });
        if(instalacion){
            const filterNewOptions = newOptions.filter((it) => it?.tipoTareaId === 3)
            setOptions(filterNewOptions);
        }else if(contrato){
            const filterNewOptions = newOptions.filter((it) => it?.tipoTareaId === 3 || it?.tipoTareaId === 5)
            setOptions(filterNewOptions);
        }else if(contratoSoft){
            if((contratoSoft === 210475 || contratoSoft === '210475')){
                const filterNewOptions = newOptions.filter((it) => it?.label?.includes('TICKET MAESTRO') && it?.label?.includes('CORTE') )
                setOptions(filterNewOptions);
            }else if((contratoSoft === 475221 || contratoSoft === '475221')){
                const filterNewOptions = newOptions.filter((it) => it?.label?.includes('TICKET MAESTRO') && it?.label?.includes('MANTENIMIENTO') )
                setOptions(filterNewOptions);
            }else{
                const filterNewOptions = newOptions.filter((it) => [1,2,4,5,6]?.includes(it?.tipoTareaId) || [7,28,36,40,94,131]?.includes(it?.value) )
                setOptions(filterNewOptions);
            }
        }else if(filterExist){
            const filterNewOptions = newOptions.filter(item => filterExist.includes(item?.value));
            setOptions(filterNewOptions);
        }else{
            setOptions(newOptions);
        }
        if (typeof value === 'string' || typeof value === 'number') {
            setSelectedValue(
                newOptions.find((opt) => opt.value === Number(value))
            );
        } else if(Array.isArray(value)){
                setSelectedValue(value.map(va=>{
                    const item = items.find(it=>it.id_mt === va);
                    if(item){
                        return {
                            label:item.motivo_mt,
                            value:item.id_mt,
                            ...item
                        };
                    }
                    return null
                }))
        }else{
            setSelectedValue(null)
        }
    }, [items,value,contrato,contratoSoft,filterExist]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (base) => ({
            ...base,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
            border: isDarkMode ? '1px solid #3d4a62' : '1px solid #000',
            boxShadow: isDarkMode 
                ? '0 4px 20px rgba(0,0,0,0.4)' 
                : '0 4px 20px rgba(0,0,0,0.08)'
        }),
        menuList: (base) => ({
            ...base,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : isDarkMode ? '#e0e0e0' : '#2c3e50',
            background: state.isSelected ? '#0364ff' : isDarkMode ? '#2d3a52' : '#fff',
            fontSize: 13,
            fontWeight: 500,
            padding: '10px 12px',
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: state.isSelected ? '#0250d0' : isDarkMode ? '#3d4a62' : '#e6f0ff',
                color: state.isSelected ? '#fff' : isDarkMode ? '#fff' : '#0364ff',
            },
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#2c3e50',
            fontSize: 13,
            fontWeight: 500
        }),
        input: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
            fontSize: 13
        }),
        placeholder: (provided) => ({
            ...provided,
            color: isDarkMode ? '#7f8c8d' : '#b0bec5',
            fontSize: 13,
            fontWeight: 400
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff',
                borderRadius: 5,
                border: isDarkMode ? '1px solid #fff' : 'none',
                border: isDarkMode ? '1px solid #fff' : 'none'
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            fontSize: 12,
            fontWeight: 500
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles, state) => ({
            ...styles,
            borderRadius: 7,
            minHeight: 45,
            borderColor: state.isFocused 
                ? isDarkMode ? '#64B5F6' : '#0364ff'
                : isDarkMode ? '#3d4a62' : 'gray',
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
            boxShadow: state.isFocused 
                ? isDarkMode 
                    ? '0 0 0 1px #64B5F6' 
                    : '0 0 0 1px #0364ff'
                : 'none',
            '&:hover': {
                borderColor: state.isFocused
                    ? isDarkMode ? '#64B5F6' : '#0364ff'
                    : isDarkMode ? '#64B5F6' : '#0364ff'
            }
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            color: isDarkMode ? '#b0bec5' : '#7f8c8d',
            '&:hover': {
                color: isDarkMode ? '#64B5F6' : '#0364ff'
            }
        }),
        clearIndicator: (provided, state) => ({
            ...provided,
            color: isDarkMode ? '#b0bec5' : '#7f8c8d',
            '&:hover': {
                color: isDarkMode ? '#ef5350' : '#d32f2f'
            }
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            backgroundColor: isDarkMode ? '#3d4a62' : '#e0e0e0'
        }),
        noOptionsMessage: (provided) => ({
            ...provided,
            color: isDarkMode ? '#b0bec5' : '#7f8c8d',
            fontSize: 13
        }),
        loadingMessage: (provided) => ({
            ...provided,
            color: isDarkMode ? '#b0bec5' : '#7f8c8d',
            fontSize: 13
        })
    }), [isDarkMode])
    return (
        <Select
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione motivo..."
            noOptionsMessage={() => 'No hay opciones disponibles'}
            loadingMessage={() => 'Cargando...'}
            options={options}
            isDisabled={isDisabled}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isMulti={isMulti}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectMotivoTicket.defaultProps = {
    isClearable: false
};

export default SelectMotivoTicket;
